export function isFractionalColumnWidths(columnWidths: number[]): boolean {
  return columnWidths.every((w) => w < 10);
}

function distributeScaledWidths(columnWidths: number[], targetTotal: number): number[] {
  if (targetTotal <= 0) {
    return columnWidths.map(() => 0);
  }

  const currentTotal = columnWidths.reduce((sum, width) => sum + width, 0);
  if (currentTotal <= 0) {
    return columnWidths.map(() => 0);
  }

  const scaledWidths = columnWidths.map((width) => Math.floor((width / currentTotal) * targetTotal));
  const distributedTotal = scaledWidths.reduce((sum, width) => sum + width, 0);

  if (scaledWidths.length > 0) {
    scaledWidths[scaledWidths.length - 1] += targetTotal - distributedTotal;
  }

  return scaledWidths;
}

export function getResolvedColumnWidthsPx(
  columnWidths: number[] | undefined,
  columns: number,
  gridWidth: number
): number[] {
  if (columnWidths?.length === columns) {
    const isFractionalUnits = isFractionalColumnWidths(columnWidths);
    if (isFractionalUnits) {
      const totalFractions = columnWidths.reduce((sum, w) => sum + w, 0);
      const pixelPerFraction = totalFractions > 0 ? gridWidth / totalFractions : 0;
      return columnWidths.map((w) => w * pixelPerFraction);
    }
    if (gridWidth > 0) {
      return distributeScaledWidths(columnWidths, gridWidth);
    }
    return columnWidths;
  }
  return Array.from({ length: columns }, () => gridWidth / columns);
}

export function getResponsiveColumnTemplate(
  columnWidths: number[] | undefined,
  columns: number
): string {
  if (
    columnWidths?.length === columns &&
    columnWidths.every((width) => Number.isFinite(width) && width > 0)
  ) {
    return columnWidths.map((width) => `${width}fr`).join(' ');
  }

  return `repeat(${columns}, 1fr)`;
}
